import { z } from 'zod';
const employeeCodeSchema = z
    .string()
    .min(4)
    .max(10)
    .regex(/^\d+$/, 'Employee code must be numeric');
export const createEmployeeSchema = z.object({
    employeeName: z.string().min(1).max(200),
    employeeCode: employeeCodeSchema,
    email: z.string().email().optional(),
    phone: z.string().max(20).optional(),
    position: z.string().max(100).optional(),
    hourlyRate: z.number().min(0).optional(),
    // The create form has always rendered an Active/Inactive switch, but this
    // schema had no field for it. Zod strips unknown keys rather than rejecting
    // them, so "create as inactive" returned 200 and silently created an active
    // employee. Declared here so the switch actually reaches the insert.
    isActive: z.boolean().optional(),
    /** The login this staff record belongs to; the server checks membership. */
    userId: z.string().uuid().nullable().optional(),
});
export const updateEmployeeSchema = z.object({
    employeeName: z.string().min(1).max(200).optional(),
    employeeCode: employeeCodeSchema.optional(),
    email: z.string().email().optional().nullable(),
    phone: z.string().max(20).optional().nullable(),
    position: z.string().max(100).optional().nullable(),
    hourlyRate: z.number().min(0).optional().nullable(),
    isActive: z.boolean().optional(),
    userId: z.string().uuid().nullable().optional(),
});
//# sourceMappingURL=employee.js.map